import { Pipeline } from '@ui/interfaces'

interface PipelinesProps {
  pipelines: Pipeline[]
}

export const Pipelines = ({ pipelines }: PipelinesProps) => {
  return (
    <div>
      {pipelines.length === 0 ? (
        <div>No pipelines</div>
      ) : (
        pipelines.map((pipeline) => <div key={pipeline.id}>{pipeline.name}</div>)
      )}
    </div>
  )
}
